module.exports = __webpack_public_path__ + "static/media/etude-quantitative-sur-securite-des-packaging-des-piles-boutons.27ea662e.jpg";